module.exports = __webpack_public_path__ + "assets/img/dayu_kcjh.5225d5b2.png";